document.addEventListener('DOMContentLoaded', () => {
    initAnimations();
    initMobileReminder();
    initModal();
    initMobileMenu();
    initSlider();
    initAnchors();
    initForm();
});

// Animations Functional

function initAnimations() {
    const elements = document.querySelectorAll('.animate');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('animate-visible');
                observer.unobserve(entry.target);
            });
    }, { threshold: 0.15 });

    elements.forEach(el => observer.observe(el));
}

// Mobile Menu Functional

function initMobileMenu() {
  const header = document.getElementById('site-header');
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (!header || !toggleBtn || !mobileMenu) return;

  const openIcon = toggleBtn.querySelector('.menu-open');
  const closeIcon = toggleBtn.querySelector('.menu-close');

  toggleBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
    openIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
  });

  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.add('hidden');
      openIcon.classList.remove('hidden');
      closeIcon.classList.add('hidden');
    });
  });
}

// Slider Functional

function initSlider() {
    const slides = document.querySelectorAll('.review-slide');
    const prev = document.querySelector('.reviews-prev');
    const next = document.querySelector('.reviews-next');
    const counter = document.querySelector('.reviews-counter');

    if (!slides.length) return;

    let index = 0;

    const showSlide = (newIndex, direction) => {
        const current = slides[index];
        const nextSlide = slides[newIndex];

        current.classList.remove('active');
        current.classList.add(direction === 'next' ? 'exit-left' : 'exit-right');

        setTimeout(() => {
        current.classList.remove('exit-left', 'exit-right');
        }, 400);

        nextSlide.classList.add('active');

        index = newIndex;

        if (counter) {
          counter.textContent = `${index + 1} / ${slides.length}`;
        }
    };

    next.addEventListener('click', () => {
        const newIndex = (index + 1) % slides.length;
        showSlide(newIndex, 'next');
    });

    prev.addEventListener('click', () => {
        const newIndex = (index - 1 + slides.length) % slides.length;
        showSlide(newIndex, 'prev');
    });

    if (counter) {
      counter.textContent = `${index + 1} / ${slides.length}`;
    }
}

// Modal Functional

function initModal() {
  const modal = document.getElementById("consult-modal");
  const overlay = document.getElementById("consult-overlay");
  const content = document.getElementById("consult-modal-content");
  const closeBtn = document.getElementById("consult-close");

  const openButtons = document.querySelectorAll("[data-modal-open]");

  if (!modal) return;

  function openModal() {
    modal.classList.remove("hidden");

    void modal.offsetWidth;

    overlay.classList.remove("opacity-0");
    content.classList.remove("opacity-0", "translate-y-5", "scale-90");

    document.body.classList.add("overflow-hidden");
  }

  function closeModal() {
    overlay.classList.add("opacity-0");
    content.classList.add("opacity-0", "translate-y-5", "scale-90");

    setTimeout(() => {
        modal.classList.add("hidden");
    }, 200);

    document.body.classList.remove("overflow-hidden");
  }

  openButtons.forEach(btn => {
      btn.addEventListener("click", openModal);
  });

  overlay.addEventListener("click", closeModal);
  closeBtn.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.classList.contains("hidden")) {
          closeModal();
      }
  });
}

// Mobile Reminder

function initMobileReminder() {
  const reminder = document.getElementById("appReminder");
  if (!reminder) return;

  const iosLink = document.getElementById("app-link-ios");
  const androidLink = document.getElementById("app-link-android");
  const closeBtn = reminder.querySelector("button");

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /android/i.test(userAgent);

  if (isIOS) {
    if (iosLink) {
      iosLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else if (isAndroid) {
    if (androidLink) {
      androidLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else {
    reminder.style.display = "none";
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      reminder.style.display = "none";
    });
  }
}

// Form Functional

function initForm() {
  document.querySelectorAll('[data-consult-form]').forEach(form => {

    const nameInput  = form.querySelector('input[name="name"]');
    const phoneInput = form.querySelector('input[name="phone"]');
    const textInput  = form.querySelector('textarea[name="description"]');

    if (!nameInput || !phoneInput || !textInput) return;

    phoneInput.value = '+380 ';

    function formatPhone(value) {
      let digits = value.replace(/\D/g, '');

      if (digits.startsWith('380')) digits = digits.slice(3);
      digits = digits.substring(0, 9);

      let result = '+380 ';

      if (digits.length > 0) {
        result += '(' + digits.substring(0, 2);
      }

      if (digits.length >= 2) {
        result += ') ' + digits.substring(2, 5);
      }

      if (digits.length >= 5) {
        result += '-' + digits.substring(5, 9);
      }

      return result;
    }

    phoneInput.addEventListener('input', function () {
      this.value = formatPhone(this.value);
    });

    phoneInput.addEventListener('keydown', function (e) {
      const isDelete = e.key === 'Backspace' || e.key === 'Delete';
      if (!isDelete) return;

      const digits = this.value.replace(/\D/g, '');

      if (this.selectionStart === 0 && this.selectionEnd === this.value.length) {
        e.preventDefault();
        this.value = '+380 ';
        return;
      }

      if (this.selectionStart <= 4) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      let clean = digits.startsWith('380')
        ? digits.slice(3)
        : digits;

      clean = clean.slice(0, -1);

      this.value = formatPhone('+380' + clean);
    });

    const isValidName = v =>
      /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

    const isValidPhone = v => {
      const clean = v.replace(/\D/g, '');
      return /^380\d{9}$/.test(clean);
    };

    const isValidText = v =>
      v.trim().length >= 2;

    form.addEventListener('submit', async e => {
      e.preventDefault();

      let valid = true;

      [nameInput, phoneInput, textInput].forEach(el =>
        el?.classList.remove('!border-red-500')
      );

      if (!isValidName(nameInput.value)) {
        nameInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!isValidPhone(phoneInput.value)) {
        phoneInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!isValidText(textInput.value)) {
        textInput.classList.add('!border-red-500');
        valid = false;
      }

      if (!valid) return;

      const cleanPhone = phoneInput.value.replace(/\D/g, '');
      const pageUrl = window.location.href;

      const formData = new URLSearchParams({
        action: 'send_to_crm',
        client_name: nameInput.value,
        client_phone: cleanPhone,
        description: textInput.value + "\n\nСторінка: " + pageUrl
      });

      try {

        const response = await fetch(myAjax.ajaxurl, {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: formData
        });

        const result = await response.json();

        if (result.success) {
          const state = form.closest('.consult-state');
          const formBlock = state.querySelector('.consult-form-block');
          const success = state.querySelector('.consult-success');

          formBlock.classList.add('hidden');
          success.classList.remove('hidden');

          setTimeout(() => {
            success.classList.remove('opacity-0', 'scale-90');
          }, 10);
        } else {
          alert('Помилка відправки');
        }

      } catch (err) {
        alert('Помилка зʼєднання');
        console.error(err);
      }
    });
  });
}

// Anchors Functional

function initAnchors() {
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();

    const header = document.querySelector('header');
    const offset = header ? header.offsetHeight : 80;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  });
}